<template>
  <div class="theProductLister">
    <img :src="thumbnailSrc" class="img-fluid space-bottom float-right" width="50%" />
    <h3 class="space-bottom-small">{{product.title}}</h3>
    <div>
      <label style="font-weight:600" >Price:</label>
      <p>{{priceString}}</p>
    </div>
    <div v-if="product.type=='engine'">
      <label style="font-weight:600">Engine Type:</label>
      <p>{{product.metadata.engine_type}}</p>
    </div>
  
    <div class="form-group smaller-drop">
      <label style="font-weight:600" for="status2">Order Status:</label>
      <select class="form-control" id="status2" v-model="product.status"
        @change="$emit('status-changed', {id: product.id, status: product.status})">
        <option value="included">Included</option>
        <option value="removed">Removed</option>
      </select>
    </div>

    

    <p class="no-bottom">{{product.description}}</p>
   
   
  </div>
</template>

<script>
  export default {
    props: {
      product: {
        type: Object,
        default: function () {
          return {
            id: "",
            type: "Product Type",
            metadata: {},
            title: "Product Title",
            price: 5.0,
            description: "Product Description",
            status: "included",
          };
        },
      },
    },
    computed: {
      priceString() {
        return this.product.price.toLocaleString(undefined, {
          style: "currency",
          currency: "USD",
        });
      },
      thumbnailSrc() {
        var id = "";
        if (typeof this.product.metadata.thumbnail != "undefined") {
          id = this.product.metadata.thumbnail;
        } else if (this.media.length != 0) {
          id = this.media[0].id;
        }
        return process.env.VUE_APP_API_URL + `/media/thumbnails/300/${id}.png`;
      },
    },
  };
</script>